package one.healthium.ui.compose.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

enum class AlertButtonType {
    DEFAULT,
    CANCEL,
    DESTRUCTIVE
}

@Composable
expect fun AppAlertDialog(
    modifier: Modifier = Modifier,
    positiveButton: String? = null,
    negativeButton: String? = null,
    onPositiveClick: (() -> Unit)? = null,
    onNegativeClick: (() -> Unit)? = null,
    positiveButtonType: AlertButtonType = AlertButtonType.DEFAULT,
    negativeButtonType: AlertButtonType = AlertButtonType.CANCEL,
    title: String? = null,
    text: String? = null,
    onDismissRequest: () -> Unit,
    dismissible: Boolean = true,
)